export default __webpack_public_path__ + "static/media/gif-posicione-rosto.babb9140.gif";